<template>
  <div class="container">
    <div class="container_form">
      <el-form
        ref="formObjRefs"
        :inline="true"
        :model="formObj"
        style="
          padding-top: 20px;
          padding-left: 20px;
          margin-bottom: 20px;
          background-color: #fff;
          border-radius: 8px;
        "
        size="small"
      >
        <el-form-item label="结算批次名称" prop="settlementBatchName">
          <el-select
            filterable
            style="width: 100%"
            v-model="formObj.settlementBatchName"
            placeholder="请选择结算批次名称"
          >
            <el-option
              v-for="(item, index) in queryFormSettlementList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算师傅名称" prop="installerIds">
          <el-select
            multiple
            style="width: 100%"
            filterable
            v-model="formObj.installerIds"
            placeholder="请选择结算师傅名称"
          >
            <el-option
              v-for="item in allUserList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司名称" prop="companyIds">
          <el-select
            multiple
            style="width: 100%"
            filterable
            v-model="formObj.companyIds"
            placeholder="请选择公司名称"
          >
            <el-option
              v-for="item in companyList"
              :key="item.companyId"
              :label="item.companyManager"
              :value="item.companyId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算时间" prop="rangeTime">
          <el-date-picker
            style="width: 220px"
            v-model="formObj.rangeTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="getPageData(true)"
            >查询</el-button
          >
          <el-button type="info" size="mini" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <div class="container_table">
        <!-- 金额统计 -->
        <AmountStatistics
          v-bind="amountStatistics"
          :showOption="['paidAmount']"
        />
        <BaseTable
          :tableData="tableData"
          :columns="columns"
          :showPagination="true"
          :showOperationColumn="true"
          :total="total"
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :operationColumnWidth="180"
        >
          <template #settlementBatchName="{ row }">
            <span class="batch-name-link" @click="jumpToReport(row.settlementBatchName)">{{ row.settlementBatchName }}</span>
          </template>
          <!-- 抵扣金额 -->
          <template #deductionAmount="{ row }">
            <span v-if="row.deductionAmount" style="color: blue">
              <el-button
                type="text"
                size="small"
                @click="seeDeductionRecords(row)"
                >{{ row.deductionAmount }}</el-button
              >
            </span>
            <span v-else>{{ row.deductionAmount || 0 }}</span>
          </template>

          <template #operation="{ row }">
            <el-tooltip effect="dark" content="修改" placement="top-end">
              <el-button
                type="warning"
                icon="el-icon-edit"
                size="mini"
                style="margin-left: 5px"
                circle
                @click="handleEditClick(row)"
              ></el-button>
            </el-tooltip>

            <el-tooltip effect="dark" content="支付记录" placement="top-end">
              <el-button
                type="info"
                content="支付记录"
                icon="el-icon-info"
                style="margin-left: 5px"
                circle
                size="mini"
                @click="record(row)"
              >
              </el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="查看" placement="top-end">
              <el-button
                type="primary"
                icon="el-icon-view"
                size="mini"
                style="margin-left: 5px"
                @click="view(row)"
                circle
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="操作记录" placement="top-end">
              <el-button
                type="info"
                icon="el-icon-s-operation"
                size="mini"
                 style="margin-left: 5px"
                @click="operationRecord(row)"
                circle
              ></el-button>
            </el-tooltip>
          </template>
        </BaseTable>
      </div>
    </div>
    <!-- 支付记录弹窗组件 -->
    <PaymentRecord 
      ref="paymentRecordRefs" 
      @see-merge-records="seeMergeRecords"
      @see-file-list="seeFileList"
    />
    <el-dialog
      title="结算单详情"
      :visible.sync="dialogNewSettlement"
      fullscreen
      custom-class="settlement-fullscreen-dialog"
      :close-on-click-modal="false"
    >
      <newSettlement ref="newSettlementRefs" :addForm="addForm"></newSettlement>
    </el-dialog>
    <Record ref="recordRefs" />
    <!-- 文件列表 -->
    <FileList ref="fileListRefs"></FileList>
    <!-- 抵扣记录 -->
    <DeductionRecord ref="deductionRecordRefs" />
    <!-- 合并支付记录 -->
    <MergePaymentRecords ref="mergePaymentRecordsRefs" />
    <!-- 确认修改组件 -->
    <ConfirmEdit 
      ref="confirmEditRefs" 
      @confirm-edit="handleConfirmEdit"
    />
  </div>
</template>

<script>
import BaseTable from "@/components/BaseTable";
import newSettlement from "@/views/settlement-model/tobe-confirmed/components/newSettlement.vue";
import Record from "@/components/Record";
import DeductionRecord from "@/views/settlement-model/components/DeductionRecord.vue";
import MergePaymentRecords from "@/views/settlement-model/components/MergePaymentRecords.vue";
import AmountStatistics from "@/views/settlement-model/components/AmountStatistics.vue";
import PaymentRecord from "@/views/settlement-model/components/PaymentRecord.vue";
import ConfirmEdit from "@/views/settlement-model/components/ConfirmEdit.vue";
import FileList from "@/components/FileList";
export default {
  name: "TobeConfirmed",
  components: {
    BaseTable,
    newSettlement,
    Record,
    FileList,
    DeductionRecord,
    MergePaymentRecords,
    AmountStatistics,
    PaymentRecord,
    ConfirmEdit,
  },
  data() {
    return {
      formObj: {
        installerIds: [],
        settlementBatchName: "",
        companyIds: [],
        rangeTime: [],
      },
      tableData: [],
      amountStatistics: {},
      columns: [
        {
          prop: "settlementBatchName",
          label: "结算批次名称",
          slot: "settlementBatchName",
        },
        {
          prop: "totalAmount",
          label: "总金额",
        },
        {
          prop: "paidAmount",
          label: "支付金额",
        },
        {
          prop: "deductionAmount",
          label: "抵扣金额",
          slot: "deductionAmount",
        },
        {
          prop: "responsibleUserIdStr",
          label: "结算师傅名称",
        },
        {
          prop: "companyIdStr",
          label: "公司名称",
        },
        {
          prop: "createTime",
          label: "创建时间",
        },
        {
          prop: "createdByStr",
          label: "创建人",
        },
        {
          prop: "updateTime",
          label: "修改时间",
        },
        {
          prop: "updatedByStr",
          label: "修改人",
        },
      ],
      companyList: this.$store.state.company || [],
      allUserList: this.$store.state.allUserList || [],
      total: 0,
      page: {
        size: 10,
        current: 1,
      },
      dialogNewSettlement: false,
      addForm: {},
      queryFormSettlementList: [],
    };
  },
  created() {
    this.getSettlementList();
    this.loadAllUserList();
    // 处理从报表页面跳转过来的查询参数
    this.handleRouteQuery();
  },
  methods: {
    // 加载所有用户列表
    async loadAllUserList() {
      try {
        // 调用store的action来获取最新的用户列表
        await this.$store.dispatch('setAllUserList');
        // 更新本地数据
        this.allUserList = this.$store.state.allUserList;
      } catch (error) {
        console.error('加载用户列表失败:', error);
        this.$message.error('加载用户列表失败');
      }
    },
    seeMergeRecords(row) {
      this.$refs.mergePaymentRecordsRefs.open(row.id);
    },
    seeDeductionRecords(row) {
      this.$refs.deductionRecordRefs.open(row.id);
    },
    seeFileList(ids) {
      const filtList = ids.split(",");
      this.$refs.fileListRefs.open(filtList);
    },
    operationRecord(row) {
      this.$refs.recordRefs.open(row);
    },
    view(row) {
      this.addForm = {
        isSee: true,
        id: row.id,
        settlementBatchName: row.settlementBatchName,
        responsibleUserId: row.responsibleUserId,
      };
      this.dialogNewSettlement = true;
    },
    getSettlementList() {
      this.axios({
        method: "post",
        url: "/pending-settlement-order/listSettlementName?status=2",
      }).then((res) => {
        this.queryFormSettlementList = res.data.data;
      });
    },
    record(row) {
      this.$refs.paymentRecordRefs.open(row.id);
    },
    
    // 处理修改按钮点击
    handleEditClick(row) {
      this.$refs.confirmEditRefs.open(row);
    },
    
    // 确认修改操作
    handleConfirmEdit(row) {
      // 刷新页面数据
      this.getPageData(false);
    },
    
    viewAndEdit(row, type) {
      this.addForm = {
        isSee: type,
        id: row.id,
        settlementBatchName: row.settlementBatchName,
        responsibleUserId: row.responsibleUserId,
      };
      this.dialogNewSettlement = true;
    },
    onSizeChange(val) {
      this.page.size = val;
      this.getPageData(false);
    },
    onCurrentChange(val) {
      this.page.current = val;
      this.getPageData(false);
    },
    getPageData(flag) {
      if (flag) {
        this.page = {
          size: 10,
          current: 1,
        };
      }
      const data = {
        page: this.page.current,
        size: this.page.size,
        queryInfoParams: {
          ...this.formObj,
          status: 2,
        },
      };
      this.axios({
        url: "/v1/web/settlement-manage/settlement-order/listPaid",
        method: "post",
        data,
      }).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.list;
          this.total = res.data.data.total;
          this.amountStatistics = res.data.data.extend;
          this.$store.dispatch("setPaymentCount");
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    reset() {
      this.$refs.formObjRefs.resetFields();
      this.getPageData(true);
    },
    jumpToReport(batchName) {
      // 跳转到结算报表页面并自动查询指定批次
      this.$router.push({
        path: '/home-admin/settlementManage/report',
        query: { 
          settlementBatchName: batchName,
          autoSearch: 'true'
        }
      });
    },
    handleRouteQuery() {
      // 处理从报表页面跳转过来的查询参数
      const query = this.$route.query;
      if (query.settlementBatchName && query.autoSearch === 'true') {
        // 设置结算批次名称并自动查询
        this.formObj.settlementBatchName = query.settlementBatchName;
        // 等待数据加载完成后再查询
        this.$nextTick(() => {
          setTimeout(() => {
            this.getPageData(true);
          }, 500); // 给一点时间让下拉选项加载完成
        });
      } else {
        // 正常加载数据
        this.getPageData(true);
      }
    }
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: rgb(238, 238, 238);
  box-sizing: border-box;
}
.container_table {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px 5px 20px 20px;
}
.batch-name-link {
  color: #409EFF;
  cursor: pointer;
}
.batch-name-link:hover {
  text-decoration: underline;
}
</style>
